import React from "react";
import contentUrl from "core/utils/contentUrl";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Thumbnail from "core/components/Thumbnail";
import Link from "arena/components/Link";
import { stripHtml } from "core/utils/string";

const PREFIX = "ContentListItem";

const classes = {
  avatar: `${PREFIX}-avatar`,
  primary: `${PREFIX}-primary`,
  item: `${PREFIX}-item`,
};

const StyledListItem = styled(ListItem)(({ theme }) => ({
  [`& .${classes.avatar}`]: {
    width: 100,
    marginTop: 5,
    marginBottom: 5,
    marginRight: 16,
    [theme.breakpoints.up("sm")]: {
      width: 120,
    },
  },
  [`& .${classes.primary}`]: {
    fontWeight: 500,
  },
  [`&.${classes.item}`]: {
    paddingTop: 10,
    paddingBottom: 10,
  },
}));

function ContentListItem({
  selected,
  content,
  type,
  onClickItem,
  productId,
  collectionId,
  previewMode,
}) {
  const to = contentUrl(content.siteUrl, { productId, collectionId });

  return (
    <StyledListItem
      dense
      selected={selected}
      button
      component={Link}
      to={to}
      alignItems="center"
      onClick={onClickItem}
      className={classes.item}
    >
      <ListItemAvatar className={classes.avatar}>
        <Thumbnail
          content={content}
          small
          isShortyGrid={type === "SHORTY"}
          previewMode={previewMode}
        />
      </ListItemAvatar>

      <ListItemText
        primary={content.title}
        primaryTypographyProps={{
          color: "textPrimary",
          className: classes.primary,
          sx:
            previewMode === "VERTICAL"
              ? {
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontSize: {
                    xs: "0.8rem",
                    sm: "1.1rem",
                  },
                }
              : undefined,
        }}
        secondary={
          previewMode === "VERTICAL"
            ? stripHtml(content.description)
            : undefined
        }
        secondaryTypographyProps={
          previewMode === "VERTICAL"
            ? {
                sx: {
                  display: "-webkit-box",
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontSize: {
                    xs: "0.8rem",
                    sm: "1.1rem",
                  },
                },
              }
            : undefined
        }
      />
    </StyledListItem>
  );
}

ContentListItem.propTypes = {
  collectionId: PropTypes.string,
  productId: PropTypes.string,
  type: PropTypes.string,
  onClickItem: PropTypes.func,
  selected: PropTypes.bool,
  previewMode: PropTypes.oneOf(["HORIZONTAL", "VERTICAL"]),
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    url: PropTypes.string.isRequired,
    siteUrl: PropTypes.string.isRequired,
  }),
};

export default ContentListItem;
